/**
 * Guardas de ruta por rol. `RequireRole` consume la lógica pura de `roles.ts`
 * (testeable aparte) y decide redirección: anónimo → /login (recordando el
 * destino); rol equivocado → su inicio. Mientras hidrata, muestra un loader.
 */
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext.js";
import { puedeAcceder, rutaInicioPorRol, type Rol } from "./roles.js";
import { Loader } from "../components/Loader.js";

export function RequireRole({
  permitidos,
  children,
}: {
  permitidos: readonly Rol[];
  children: ReactNode;
}) {
  const { usuario, rol, cargando } = useAuth();
  const location = useLocation();

  if (cargando) return <Loader />;
  if (!usuario) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!puedeAcceder(rol, permitidos)) {
    return <Navigate to={rutaInicioPorRol(rol!)} replace />;
  }
  return <>{children}</>;
}

/** Solo autenticación, sin exigir rol específico. */
export function RequireAuth({ children }: { children: ReactNode }) {
  return <RequireRole permitidos={[]}>{children}</RequireRole>;
}
